import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import {
  GetSimulationRatingResponse,
  IdCheckResponseBody,
  SaveSimulationResponseBody,
} from 'api/types/sim'

class Sim {
  // Get simulation by product code
  async getSimulator(productCode: string): Promise<any | (AxiosError | Error)> {
    const url = `${APIRoutes.sim.getSimulation}?Code=${productCode}`
    return ApiProvider.getRequest(url) as Promise<any | (AxiosError | Error)>
  }

  // check client NIF
  async idCheck({
    brokerNo,
    nif,
  }: {
    brokerNo: string
    nif: number
  }): Promise<IdCheckResponseBody | (AxiosError | Error)> {
    const url = `${APIRoutes.sim.idCheck}?brokerNo=${brokerNo}&nif=${nif}`
    return ApiProvider.getRequest(url) as Promise<
      IdCheckResponseBody | (AxiosError | Error)
    >
  }

  // get simulation rating
  async getSimulationRating({
    answers,
  }: {
    answers: any
  }): Promise<GetSimulationRatingResponse | (AxiosError | Error)> {
    const url = APIRoutes.sim.getSimulationRating
    return ApiProvider.postRequest(url, { ...answers }) as Promise<
      GetSimulationRatingResponse | (AxiosError | Error)
    >
  }

  // save simulation as quotation
  async submitSimulation({
    answers,
  }: {
    answers: any
  }): Promise<SaveSimulationResponseBody | (AxiosError | Error)> {
    const url = APIRoutes.sim.submitSimulation
    return ApiProvider.postRequest(url, { ...answers }) as Promise<
      SaveSimulationResponseBody | (AxiosError | Error)
    >
  }

  async createNewBusiness({
    policyNo,
    brokerNo,
    fullProcess,
  }: {
    policyNo: number
    brokerNo: string
    fullProcess: 0 | 1
  }): Promise<any | (AxiosError | Error)> {
    const url = `${APIRoutes.sim.createNewBusiness}?policyNo=${policyNo}&brokerNo=${brokerNo}&fullProcess=${fullProcess}`
    return ApiProvider.postRequest(url, {}) as Promise<
      any | (AxiosError | Error)
    >
  }

  async logSimulationInfo({
    simCode,
    eventType,
    observation,
  }: {
    simCode: string
    eventType: string
    observation?: string
  }): Promise<any | (AxiosError | Error)> {
    const url = `${APIRoutes.sim.logSimulationInfo}?simCode=${simCode}&eventType=${eventType}&observation=${observation}`
    return ApiProvider.postRequest(url, {}) as Promise<
      any | (AxiosError | Error)
    >
  }
}

export const simService = new Sim()
